import CoveredInClassHFv4 from './component';

import _routes from './routes';

export const routes = _routes;

export default CoveredInClassHFv4;



// WEBPACK FOOTER //
// ./containers/Group/CoveredInClassHFv4/index.js